<div class="dashboard-content">
    <h1 class="visually-hidden">My Account</h1>
    <div class="visually-hidden" role="status" aria-live="polite" aria-atomic="true" #liveRegion></div>

    <div class="container mt-4">
        <div class="row" id="main-content">
            <div class="col-xxl-1"></div>
            <div class="col-xxl-10">
                <div class="row g-4 mb-2">
                    <div class="col-12">
                        <form [formGroup]="accountForm" (submit)="updateAccount($event)" novalidate>
                            <div class="card">

                                <div class="card-header mt-2">
                                    <div class="d-flex align-items-center">
                                        <i class="fa-solid fa-circle-user material-icon-fa card-title-icon me-2"
                                            aria-hidden="true"></i>
                                        <h2 class="dashboard-card-title">My Account</h2>
                                    </div>
                                    <p class="dashboard-card-subtitle mt-1">Update Account Information</p>
                                </div>

                                <div class="card-body p-3">

                                    @if (isLoading()) {
                                    <div class="account-empty-state d-flex justify-content-center align-items-center">
                                        <div class="spinner-border spinner-border-lg text-primary" role="status">
                                            <span class="visually-hidden">Loading account information...</span>
                                        </div>
                                    </div>
                                    } @else {

                                    @if (alertState()) {
                                    <div class="alert alert-{{ alertState()!.type }} alert-dismissible" role="alert"
                                        aria-live="assertive">
                                        {{ alertState()!.message }}
                                        <button type="button" class="btn-close" aria-label="Dismiss alert"
                                            (click)="alertState.set(null)"></button>
                                    </div>
                                    }

                                    <!-- Name
                                    <div class="row g-3 mb-4">
                                        <div class="col-12">
                                            <h5 class="form-section-heading">Name</h5>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mdb-form-control>
                                                <input mdbValidate mdbInput type="text" id="firstName"
                                                    formControlName="firstName" class="form-control"
                                                    autocomplete="given-name" aria-required="true"
                                                    [attr.aria-describedby]="firstName.invalid && firstName.touched ? 'firstName-error' : null" />
                                                <label mdbLabel class="form-label" for="firstName">
                                                    First Name <span class="form-required-asterisk"
                                                        aria-hidden="true">*</span>

                                                </label>
                                                @if (firstName.invalid && firstName.touched) {
                                                <mdb-error id="firstName-error">First name is required.</mdb-error>
                                                }
                                                @if (firstName.valid && firstName.touched) {
                                                <mdb-success></mdb-success>
                                                }
                                            </mdb-form-control>
                                        </div>
                                        <div class="col-12 col-md-4">
                                            <mdb-form-control>
                                                <input mdbValidate mdbInput type="text" id="lastName"
                                                    formControlName="lastName" class="form-control"
                                                    autocomplete="family-name" aria-required="true"
                                                    [attr.aria-describedby]="lastName.invalid && lastName.touched ? 'lastName-error' : null" />
                                                <label mdbLabel class="form-label" for="lastName">
                                                    Last Name <span class="form-required-asterisk"
                                                        aria-hidden="true">*</span>

                                                </label>
                                                @if (lastName.invalid && lastName.touched) {
                                                <mdb-error id="lastName-error">Last name is required.</mdb-error>
                                                }
                                                @if (lastName.valid && lastName.touched) {
                                                <mdb-success></mdb-success>
                                                }
                                            </mdb-form-control>
                                        </div>
                                    </div> -->

                                    <!-- Contact Information 
                                    <div class="row g-3 mb-4">
                                        <div class="col-12">
                                            <h5 class="form-section-heading">Contact Information</h5>
                                        </div> -->

                                    <!-- Email row 
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 col-md-4 mt-4 mt-md-2">
                                                    <mdb-form-control>
                                                        <input mdbValidate mdbInput type="email" id="email"
                                                            formControlName="email" class="form-control"
                                                            autocomplete="email"
                                                            [attr.aria-describedby]="emailField.invalid && emailField.touched ? 'email-error' : null" />
                                                        <label mdbLabel class="form-label" for="email">Email
                                                            Address</label>
                                                        @if (emailField.invalid && emailField.touched) {
                                                        <mdb-error id="email-error">
                                                            @if (emailField.hasError('email')) { Please enter a valid
                                                            email address. }
                                                            @else if (emailField.hasError('contactRequired')) { Please
                                                            provide an email or phone number. }
                                                        </mdb-error>
                                                        }
                                                        @if (emailField.valid && emailField.touched) {
                                                        <mdb-success></mdb-success>
                                                        }
                                                    </mdb-form-control>
                                                </div>
                                                @if (emailChanged()) {
                                                <div class="col-12 col-md-4 mt-4 mt-md-2">
                                                    <mdb-form-control>
                                                        <input mdbValidate mdbInput type="email" id="confirmEmail"
                                                            formControlName="confirmEmail" class="form-control"
                                                            autocomplete="off" aria-required="true"
                                                            aria-describedby="confirmEmail-error" />
                                                        <label mdbLabel class="form-label" for="confirmEmail">
                                                            Confirm New Email <span class="form-required-asterisk"
                                                                aria-hidden="true">*</span>

                                                        </label>
                                                        @if (accountForm.hasError('confirmEmailRequired')) {
                                                        <mdb-error id="confirmEmail-error">Please confirm your new email
                                                            address.</mdb-error>
                                                        } @else if (accountForm.hasError('confirmEmailMismatch')) {
                                                        <mdb-error id="confirmEmail-error">Email addresses do not
                                                            match.</mdb-error>
                                                        }
                                                    </mdb-form-control>
                                                </div>
                                                }
                                            </div>
                                        </div>-->

                                    <!-- Phone row 
                                        <div class="col-12">
                                            <div class="row">
                                                <div class="col-12 col-md-4 mt-4 mt-md-2">
                                                    <mdb-form-control>
                                                        <input mdbValidate mdbInput type="tel" id="phone"
                                                            formControlName="phone" class="form-control"
                                                            autocomplete="tel"
                                                            [attr.aria-describedby]="phoneField.invalid && phoneField.touched ? 'phone-error' : null" />
                                                        <label mdbLabel class="form-label" for="phone">Phone
                                                            Number</label>
                                                        @if (phoneField.invalid && phoneField.touched) {
                                                        <mdb-error id="phone-error">
                                                            @if (phoneField.hasError('usaPhone')) { Please enter a valid
                                                            US phone number. }
                                                            @else if (phoneField.hasError('contactRequired')) { Please
                                                            provide an email or phone number. }
                                                        </mdb-error>
                                                        }
                                                        @if (phoneField.valid && phoneField.touched) {
                                                        <mdb-success></mdb-success>
                                                        }
                                                    </mdb-form-control>
                                                </div>
                                                @if (phoneChanged()) {
                                                <div class="col-12 col-md-4 mt-4 mt-md-2">
                                                    <mdb-form-control>
                                                        <input mdbValidate mdbInput type="tel" id="confirmPhone"
                                                            formControlName="confirmPhone" class="form-control"
                                                            autocomplete="off" aria-required="true"
                                                            aria-describedby="confirmPhone-error" />
                                                        <label mdbLabel class="form-label" for="confirmPhone">
                                                            Confirm New Phone <span class="form-required-asterisk"
                                                                aria-hidden="true">*</span>

                                                        </label>
                                                        @if (accountForm.hasError('confirmPhoneRequired')) {
                                                        <mdb-error id="confirmPhone-error">Please confirm your new phone
                                                            number.</mdb-error>
                                                        } @else if (accountForm.hasError('confirmPhoneMismatch')) {
                                                        <mdb-error id="confirmPhone-error">Phone numbers do not
                                                            match.</mdb-error>
                                                        }
                                                    </mdb-form-control>
                                                </div>
                                                }
                                            </div>
                                        </div>

                                        @if (accountForm.hasError('atLeastOneContact') && accountForm.touched) {
                                        <div class="col-12">
                                            <p class="text-danger small" role="alert">Please provide at least one
                                                contact method.</p>
                                        </div>
                                        }-->
                                    <!--</div>-->

                                    <!-- Address -->
                                    <div class="row g-3 mb-4">
                                        <div class="col-12">
                                            <h5 class="form-section-heading">Address</h5>
                                        </div>
                                        <div class="col-12">
                                            <div class="row mb-2">
                                                <div class="col-12 col-md-7">
                                                    <mdb-form-control>
                                                        <input mdbInput type="text" id="address1"
                                                            formControlName="address1" class="form-control"
                                                            autocomplete="address-line1" />
                                                        <label mdbLabel class="form-label" for="address1">Address Line
                                                            1</label>
                                                    </mdb-form-control>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12">
                                            <div class="row mb-2">
                                                <div class="col-12 col-md-7">
                                                    <mdb-form-control>
                                                        <input mdbInput type="text" id="address2"
                                                            formControlName="address2" class="form-control"
                                                            autocomplete="address-line2" />
                                                        <label mdbLabel class="form-label" for="address2">Address Line
                                                            2</label>
                                                    </mdb-form-control>
                                                </div>
                                            </div>
                                        </div>


                                        <div class="col-12 col-md-3">
                                            <mdb-form-control>
                                                <input mdbInput type="text" id="city" formControlName="city"
                                                    class="form-control" autocomplete="address-level2" />
                                                <label mdbLabel class="form-label" for="city">City</label>
                                            </mdb-form-control>
                                        </div>
                                        <div class="col-12 col-md-2">
                                            <mdb-form-control>
                                                <mdb-select formControlName="state" autocomplete="address-level1">
                                                    @for (option of states; track option.value) {
                                                    <mdb-option [value]="option.value">{{ option.label }}</mdb-option>
                                                    }
                                                </mdb-select>
                                                <label mdbLabel class="form-label">State</label>
                                            </mdb-form-control>
                                        </div>
                                        <div class="col-12 col-md-2">
                                            <mdb-form-control>
                                                <input mdbInput type="text" id="zipCode" formControlName="zipCode"
                                                    class="form-control" autocomplete="postal-code"
                                                    inputmode="numeric" maxlength="5"
                                                    [attr.aria-invalid]="zipCodeField.invalid && (zipCodeField.dirty || zipCodeField.touched)"
                                                    [attr.aria-describedby]="zipCodeField.invalid && (zipCodeField.dirty || zipCodeField.touched) ? 'zipCode-error' : null" />
                                                <label mdbLabel class="form-label" for="zipCode">ZIP Code</label>
                                                @if (zipCodeField.invalid && (zipCodeField.dirty || zipCodeField.touched)) {
                                                <mdb-error id="zipCode-error" class="mt-n1">Please enter a valid 5-digit ZIP
                                                    code.</mdb-error>
                                                }
                                            </mdb-form-control>
                                        </div>
                                    </div>

                                    <!-- Contact Preferences -->
                                    <div class="row g-3 mb-2">
                                        <div class="col-12">
                                            <h5 class="form-section-heading">Contact Preferences</h5>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <mdb-form-control>
                                                <mdb-select formControlName="preferredContact">
                                                    <mdb-option value="">Select a contact method</mdb-option>
                                                    @for (option of availableContactMethods(); track option.value) {
                                                    <mdb-option [value]="option.value">{{ option.label }}</mdb-option>
                                                    }
                                                </mdb-select>
                                                <label mdbLabel class="form-label">Preferred Contact Method</label>
                                            </mdb-form-control>
                                        </div>
                                        <div class="col-12 col-md-3">
                                            <mdb-form-control>
                                                <mdb-select formControlName="preferredLanguage">
                                                    <mdb-option value="">Select a language</mdb-option>
                                                    @for (option of languages; track option.value) {
                                                    <mdb-option [value]="option.value">{{ option.label }}</mdb-option>
                                                    }
                                                </mdb-select>
                                                <label mdbLabel class="form-label">Preferred Language</label>
                                            </mdb-form-control>
                                        </div>
                                    </div>

                                    }
                                </div>
                                <!-- end card-body -->

                                <div class="card-footer">
                                    <div class="row">
                                        <div class="col-1 col-md-2"></div>
                                        <div class="col-10 col-md-8">
                                            <div class="d-grid gap-2 text-center">
                                                <button type="submit" class="btn btn-lg btn-primary"
                                                    aria-label="Save Changes" [disabled]="isLoading()" mdbRipple>
                                                    Save Changes
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-1 col-md-2"></div>
                                    </div>
                                </div>
                                <!-- end card-footer -->

                            </div>
                            <!-- end card -->
                        </form>
                    </div>
                </div>
            </div>
            <!-- end col-xxl-10 -->
            <div class="col-xxl-1"></div>
        </div>
        <!-- end row -->
    </div>
    <!-- end container -->

    <footer class="gradient-bar-footer" aria-label="Page footer">
        <div class="container">
            <div class="row">
                <div class="col-xxl-1"></div>
                <div class="col-xxl-10">
                    <app-gradientsegmentbar role="presentation" aria-hidden="true"></app-gradientsegmentbar>
                </div>
                <div class="col-xxl-1"></div>
            </div>
        </div>
    </footer>
</div>
<!-- end dashboard-content -->
